import { render, staticRenderFns } from "./PageDetails.vue?vue&type=template&id=7940c0b1&"
import script from "./PageDetails.vue?vue&type=script&lang=js&"
export * from "./PageDetails.vue?vue&type=script&lang=js&"
import style0 from "./PageDetails.vue?vue&type=style&index=0&id=7940c0b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports